import {
  PASSWORD_MIN_LENGTH,
  PASSWORD_STRENGTH_AVERAGE,
  PASSWORD_STRENGTH_GOOD,
  PASSWORD_STRENGTH_NONE,
  PASSWORD_STRENGTH_WEAK,
} from "@shared/constants";

export type PasswordStrength =
  | typeof PASSWORD_STRENGTH_NONE
  | typeof PASSWORD_STRENGTH_WEAK
  | typeof PASSWORD_STRENGTH_AVERAGE
  | typeof PASSWORD_STRENGTH_GOOD;

const GOOD_PASSWORD_MIN_LENGTH = 12;
const SYMBOL_REGEX = /[^a-zA-Z0-9]/;
const CAPITAL_LETTER_REGEX = /[A-Z]/;

export default function getPasswordStrength(
  password: string,
): PasswordStrength {
  if (password.length < PASSWORD_MIN_LENGTH) {
    return PASSWORD_STRENGTH_NONE;
  }

  const hasSymbol = SYMBOL_REGEX.test(password);

  if (
    password.length >= GOOD_PASSWORD_MIN_LENGTH &&
    hasSymbol &&
    CAPITAL_LETTER_REGEX.test(password)
  ) {
    return PASSWORD_STRENGTH_GOOD;
  }

  if (hasSymbol) {
    return PASSWORD_STRENGTH_AVERAGE;
  }

  return PASSWORD_STRENGTH_WEAK;
}
